import Model from './Model'

export default class Mailtag extends Model {
    resource() {
        return 'mailtag'
    }
}
